import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Blue from "./Blue";
import Cyan from "./Cyan";
import Green from "./Green";
import Lime from "./Lime";
import Orange from "./Orange";
import Pink from "./Pink";
import Red from "./Red";
import Yellow from "./Yellow";
import Purple from "./Purple";
import Results from "./Results";

export default function Experience() {
	const [red, setRed] = useState(0);
	const [orange, setOrange] = useState(0);
	const [yellow, setYellow] = useState(0);
	const [lime, setLime] = useState(0);
	const [green, setGreen] = useState(0);
	const [cyan, setCyan] = useState(0);
	const [blue, setBlue] = useState(0);
	const [purple, setPurple] = useState(0);
	const [pink, setPink] = useState(0);

	return (
		<Routes>
			<Route index element={<Red setValue={setRed} value={red} />} />
			<Route path="/2" element={<Orange setValue={setOrange} value={orange} />} />
			<Route path="/3" element={<Yellow setValue={setYellow} value={yellow} />} />
			<Route path="/4" element={<Lime setValue={setLime} value={lime} />} />
			<Route path="/5" element={<Green setValue={setGreen} value={green} />} />
			<Route path="/6" element={<Cyan setValue={setCyan} value={cyan} />} />
			<Route path="/7" element={<Blue setValue={setBlue} value={blue} />} />
			<Route path="/8" element={<Purple setValue={setPurple} value={purple} />} />
			<Route path="/9" element={<Pink setValue={setPink} value={pink} />} />
			<Route
				path="/results"
				element={
					<Results
						red={red}
						orange={orange}
						yellow={yellow}
						lime={lime}
						green={green}
						cyan={cyan}
						blue={blue}
						purple={purple}
						pink={pink}
					/>
				}
			/>
		</Routes>
	);
}
